export default __webpack_public_path__ + "static/media/baby-5.8b86289d.svg";